import React, { useState, useEffect } from 'react';
import { Grid, Typography, Layout } from 'antd';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-hot-toast';
import fetchCallsList from '../utils/call/fetchCallsList';
import CallEmptyState from '../components/call/CallEmptyState';
import CallDialer from '../components/call/CallDialer';
import CallList from '../components/call/CallList';
import LoadingCard from '../components/LoadingCard';
import FAQ from '../components/FAQ';

const { Content } = Layout;
const { useBreakpoint } = Grid;

export default function Calls() {
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const [calls, setCalls] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [loading, setLoading] = useState(true);
  const [reloadTrigger, setReloadTrigger] = useState(0);

  const handleCallEnded = async () => {
    // wait a sec for the backend to record the call…
    await new Promise(r => setTimeout(r, 1000));
    setReloadTrigger(trig => trig + 1);
  };

  const loadCalls = async (page = 1) => {
    setLoading(true);
    try {
      const { calls: fetched, pagination: meta } = await fetchCallsList(page);
      setCalls(fetched);
      setPagination(meta);
    } catch (err) {
      console.error(err);
      toast.error(t('calls.errors.fetch_error'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCalls(pagination.current);
  }, [reloadTrigger]);

  return (
    <Content className="page calls-page">
      {calls.length > 0 && (
        <CallDialer onCallEnded={handleCallEnded} />
      )}

      {loading ? (
        <LoadingCard />
      ) : calls.length > 0 ? (
        <div style={{ marginTop: 40 }}>
          <CallList
            calls={calls}
            pagination={pagination}
            onPageChange={page => {
              setPagination(p => ({ ...p, current: page }));
              loadCalls(page);
            }}
          />
        </div>
      ) : (
        <CallEmptyState onCallEnded={handleCallEnded} />
      )}
      <div style={{ marginTop: 40 }}>
        <FAQ localeKey={"faq_calls"}/>
      </div>
    </Content>
  );
}